import { connect } from 'react-redux';
import Download from './components/Download';

import { loadUser } from '../../redux/actions/user';
import { fileDownload } from '../../redux/actions/download';

const mapStateToProps = (state) => ({
  status: state.ioc.detailsStatus,
  downloadStatus: state.download.downloadFileStatus,
});

const mapDispatchToProps = {
  loadUser,
  fileDownload,
};

export default connect(mapStateToProps, mapDispatchToProps)(Download);
